import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('../components/home.vue')
const Wellcome = () => import('../components/wellcome.vue')
const ViewMaterial = () => import('../view/ViewMaterial.vue')
const Login = () => import('../components/login/login.vue')
const ChangePWD = () => import('../components/ChangePWD/ChangePWD.vue')
const TaskDelivery = () => import('../view/TaskDelivery.vue')
const carControl = () => import('../view/carControl.vue')
const sampleLog = () => import('../view/sampleLog.vue')
const thailandGoods = () => import('../view/thailandGoods.vue')
const module = () => import('@/view/module.vue')
const staffManagement = () => import('@/view/staffManagement.vue')
const usermanager = () => import('@/view/usermanager.vue')
const test6 = () => import('@/view/test6.vue')
const getComputInformation = () => import('@/view/getComputInformation.vue')
const AdministrativeInformation = () => import('@/view/AdministrativeInformation.vue')
const companyManager = () => import('@/view/companyManager.vue')
const cdStockInfo = () => import('@/view/cdStockInfo.vue')
const truckInfo = () => import('@/view/truckInfo.vue')
const driverInfo = () => import('@/view/driverInfo.vue')
const address = () => import('@/view/address.vue')
const taskList = () => import('@/view/taskList.vue')
const freightList = () => import('@/view/freightList.vue')
const dictionaryType = () => import('@/view/dictionaryType.vue')
const dictionaryData = () => import('@/view/dictionaryData.vue')
const preview = () => import('@/components/preview.vue')
const payroll = () => import('@/view/payroll.vue')
const screen = () => import('@/view/screen.vue')
const exportDeclare = () => import('@/view/AEO/exportDeclare.vue')
const exportDeclareML = () => import('@/view/AEO/exportDeclareML.vue')
const importDeclare = () => import('@/view/AEO/importDeclare.vue')
const importDeclareML = () => import('@/view/AEO/importDeclareML.vue')
const declareSearch = () => import('@/view/AEO/declareSearch.vue')
const invtExport = () => import('@/view/AEO/invtExport.vue')
const invtImport = () => import('@/view/AEO/invtImport.vue')
const invtSelect = () => import('@/view/AEO/invtSelect.vue')
const prohibitedClass = () => import('@/view/AEO/prohibitedClass.vue')
const declareUpload = () => import('@/view/AEO/declareUpload.vue')
const importData = () => import('@/view/AEO/importData.vue')
const insWrongRecord = () => import('@/view/AEO/insWrongRecord.vue')
const fa = () => import('@/view/fa.vue')
const goodStockInOut = () => import('@/view/goodStockInOut.vue')
const stock = () => import('@/view/stock.vue')
const files = () => import('@/view/files.vue')
const dualUseItem = () => import('@/view/AEO/AIModel/dualUseItem.vue')
const dualUseItemClassification = () => import('@/view/AEO/AIModel/dualUseItemClassification.vue')

// 仓库
const warehouse = () => import('@/view/wms/basicData/warehouse.vue')
const goods = () => import('@/view/wms/basicData/goods.vue')
const handbook = () => import('@/view/wms/basicData/handbook.vue')
const inAndOutList = () => import('@/view/wms/inAndOutList.vue')
const inWarehouse = () => import('@/view/wms/inWarehouse.vue')
const outbound = () => import('@/view/wms/outbound.vue')
const inventoryList = () => import('@/view/wms/inventoryList.vue')
const interWarehouseList = () => import('@/view/wms/interWarehouseList.vue')
const inventoryMove = () => import('@/view/wms/inventoryMove.vue')
const inAndOutTaskList = () => import('@/view/wms/inAndOutTaskList.vue')
const ownerTransfer = () => import('@/view/wms/ownerTransfer.vue')
const InventoryCountList = () => import('@/view/wms/InventoryCountList.vue')
const InventoryCount = () => import('@/view/wms/InventoryCount.vue')
const locationMap = () => import('@/view/wms/locationMap.vue')
const wmsDailyReport = () => import('@/view/wms/wmsDailyReport.vue')
const overduePickList = () => import('@/view/wms/overduePickList.vue')
const monthlyReport = () => import('@/view/wms/monthlyReport.vue')
const weekReport = () => import('@/view/wms/weekReport.vue')
const workLoadReport = () => import('@/view/wms/workLoadReport.vue')
const dayStockReport = () => import('@/view/wms/dayStockReport.vue')
const cncdPuple = () => import('@/view/tools/cncdPuple.vue')
const AIResource = () => import('@/view/AI/AIResource.vue')
const AIwms = () => import('@/view/wms/AIwms.vue')


// 引入加载条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 配置
NProgress.inc()
NProgress.configure({     
    easing: 'ease',  // 动画方式    
    speed: 800,  // 递增进度条的速度    
    showSpinner: false, // 是否显示加载ico    
    trickleSpeed: 200, // 自动递增间隔    
    minimum: 0.1 // 初始化时的最小百分比
})

Vue.use(VueRouter)

// 所有人都可以访问
const routes = [
    {path: '/', redirect: '/login'},
    {path:'/login', component:Login},
    {path:'/getComputInformation', component:getComputInformation},
    { path: '/preview', component: preview},
    // 访问home时，重定向到wellcome页
    { path: '/changePWD', name: 'changePWD', component: ChangePWD, meta: {title: '修改密码'}},
    { path: '/screen', name: 'screen', component: screen, meta: {title: '大屏'}},
    { path: '/inWarehouse', name: 'inWarehouse', component: inWarehouse, meta: {title: '入库任务单'}},
    { path: '/outbound', name: 'outbound', component: outbound, meta: {title: '出库任务单'}},
    { path: '/inventoryMove', name: 'inventoryMove', component: inventoryMove, meta: {title: '移库任务单'}},
    { path: '/ownerTransfer', name: 'ownerTransfer', component: ownerTransfer, meta: {title: '货转任务单'}},
    { path: '/InventoryCount', name: 'InventoryCount', component: InventoryCount, meta: {title: '盘点任务单'}},
    
    { path: '/home', name: 'home', component: Home, redirect: '/wellcome', meta: {title: '首页'}, 
        children: [
        { path: '/wellcome', name: 'wellcome', component: Wellcome, meta: {title: '首页'}}, 
        { path: '/viewMaterial', name: 'viewMaterial', component: ViewMaterial, meta: {title: '查看物料'}}, 
        { path: '/taskDelivery', name: 'taskDelivery', component: TaskDelivery, meta: {title: '任务下发'}},
        { path: '/carControl', name: 'carControl', component: carControl, meta: {title: '货样广告品'}},
        { path: '/sampleLog', name: 'sampleLog', component: sampleLog, meta: {title: '操作日志'}},
        { path: '/thailandGoods', name: 'thailandGoods', component: thailandGoods, meta: {title: '泰国备件管理'}},
        { path: '/module', name: 'module', component: module, meta: {title: '模块管理'}},
        { path: '/staffManagement', name: 'staffManagement', component: staffManagement, meta: {title: '角色管理'}},
        { path: '/usermanager', name: 'usermanager', component: usermanager, meta: {title: '用户管理'}},
        { path: '/test6', name: 'test6', component: test6, meta: {title: '测试'}},
        { path: '/userPcInfo', name: 'userPcInfo', component: AdministrativeInformation, meta: {title: '行政资产盘查'}},
        { path: '/companyManager', name: 'companyManager', component: companyManager, meta: {title: '企业信息管理'}},
        { path: '/cdStockInfo', name: 'cdStockInfo', component: cdStockInfo, meta: {title: '建发EDI'}},
        { path: '/truckInfo', name: 'truckInfo', component: truckInfo, meta: {title: '车辆信息'}},
        { path: '/driverInfo', name: 'driverInfo', component: driverInfo, meta: {title: '司机信息'}},
        { path: '/address', name: 'address', component: address, meta: {title: '地址信息'}},
        { path: '/taskList', name: 'taskList', component: taskList, meta: {title: '运输任务'}},
        { path: '/freightList', name: 'freightList', component: freightList, meta: {title: '司机运费表'}},
        { path: '/dictionaryType', name: 'dictionaryType', component: dictionaryType, meta: {title: '字典类型'}},
        { path: '/dictionaryData', name: 'dictionaryData', component: dictionaryData, meta: {title: '字典数据'}},
        { path: '/payroll', name: 'payroll', component: payroll, meta: {title: '司机工资表'}},
        { path: '/exportDeclare', name: 'exportDeclare', component: exportDeclare, meta: {title: '出口报关单'}},
        { path: '/exportDeclareML', name: 'exportDeclareML', component: exportDeclareML, meta: {title: '出口备案清单'}},
        { path: '/importDeclare', name: 'importDeclare', component: importDeclare, meta: {title: '进口报关单'}},
        { path: '/importDeclareML', name: 'importDeclareML', component: importDeclareML, meta: {title: '进口备案清单'}},
        { path: '/invtExport', name: 'invtExport', component: invtExport, meta: {title: '出口保税核注清单'}},
        { path: '/invtImport', name: 'invtImport', component: invtImport, meta: {title: '进口保税核注清单'}},
        { path: '/invtSelect', name: 'invtSelect', component: invtSelect, meta: {title: '保税核注清单查询'}},
        { path: '/prohibitedClass', name: 'prohibitedClass', component: prohibitedClass, meta: {title: '禁止、限制类商品'}},
        { path: '/declareUpload', name: 'declareUpload', component: declareUpload, meta: {title: '上传单据'}},
        { path: '/declareSearch', name: 'declareSearch', component: declareSearch, meta: {title: '报关查询'}},
        { path: '/importData', name: 'importData', component: importData, meta: {title: '数据导入'}},
        { path: '/insWrongRecord', name: 'insWrongRecord', component: insWrongRecord, meta: {title: '驳回记录'}},
        { path: '/goodStockInOut', name: 'goodStockInOut', component: goodStockInOut, meta: {title: '物资出入库'}},
        { path: '/fa', name: 'fa', component: fa, meta: {title: '资产管理'}},
        { path: '/stock', name: 'stock', component: stock, meta: {title: '物资库存'}},
        { path: '/files', name: 'files', component: files, meta: {title: '文件管理'}},
        { path: '/dualUseItem', name: 'dualUseItem', component: dualUseItem, meta: {title: '两用物项规则'}},
        { path: '/dualUseItemClassification', name: 'dualUseItemClassification', component: dualUseItemClassification, meta: {title: '两用物项分类'}},
        // 自助工具
        { path: '/cncdPuple', name: 'cncdPuple', component: cncdPuple, meta: {title: '建发纸浆指令'}},

        // 仓库
        { path: '/warehouse', name: 'warehouse', component: warehouse, meta: {title: '仓库信息'}},
        { path: '/goods', name: 'goods', component: goods, meta: {title: '货物信息'}},
        { path: '/handbook', name: 'handbook', component: handbook, meta: {title: '账册信息'}},
        { path: '/inAndOutList', name: 'inAndOutList', component: inAndOutList, meta: {title: '出入库任务列表'}},
        { path: '/inventoryList', name: 'inventoryList', component: inventoryList, meta: {title: '库存列表'}},
        { path: '/interWarehouseList', name: 'interWarehouseList', component: interWarehouseList, meta: {title: '库间作业列表'}},
        { path: '/inAndOutTaskList', name: 'inAndOutTaskList', component: inAndOutTaskList, meta: {title: '出入库作业列表'}},
        { path: '/InventoryCountList', name: 'InventoryCountList', component: InventoryCountList, meta: {title: '盘点作业列表'}},
        { path: '/locationMap', name: 'locationMap', component: locationMap, meta: {title: '库位图'}},
        { path: '/wmsDailyReport', name: 'wmsDailyReport', component: wmsDailyReport, meta: {title: '日收发存报表'}},
        { path: '/monthlyReport', name: 'monthlyReport', component: monthlyReport, meta: {title: '月报表'}},
        { path: '/weekReport', name: 'weekReport', component: weekReport, meta: {title: '周报表'}},
        { path: '/workLoadReport', name: 'workLoadReport', component: workLoadReport, meta: {title: '工作量报表'}},
        { path: '/dayStockReport', name: 'dayStockReport', component: dayStockReport, meta: {title: '仓库天数报表'}},
        { path: '/overduePickList', name: 'overduePickList', component: overduePickList, meta: {title: '保税提离'}},
            
            
        // AI
        { path: '/AIResource', name: 'AIResource', component: AIResource, meta: {title: 'AI资源管理'}},
        { path: '/AIwms', name: 'AIwms', component: AIwms, meta: {title: 'WMS AI助手'}},

        
        ] 
    },
   
]

const router = new VueRouter({
  routes
})

/**
 * 挂载路由守卫
 * to 代表将要访问的路径
 * from 代表从哪个路径跳转而来
 * next 是一个函数，next() 放行。   next('/login') 强制跳转
 */
router.beforeEach((to, from, next) => {
    // 加载条
    NProgress.start()

    //放行
    next() 
})


// 挂载路由守卫 - 访问结束
router.afterEach(() => {
    // 关闭加载条
    NProgress.done()
})

export default router
